/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagingHeader } from '../models/PagingHeader';
import { OpenAPI } from '../core/OpenAPI';
import { requestApiResult as __requestApiResult } from '../core/request';
import { ApiResult } from '../core/ApiResult';

export class ProductSalesService {

    public static async getSalesView(token: string,
        pagingRange: string,
        filter?: Record<string, string>,
        search?: Record<string, string>
    ): Promise<ApiResult> {
        return await __requestApiResult(OpenAPI, {
            method: 'GET',
            url: '/api/Query',
            headers: {
                Range: `pages=${pagingRange}`,
                Authorization: `Bearer ${token}`
            },
            query: {
                'filter': filter,
                'search': search,
                'command': 'salesView'
            },
            responseHeader: 'Content-Range'
        });
    }
}
